import apiFetch from '../../api';
import { readResponseError } from '../../errorDetail';
import { appendGeoMetadata } from '../../utils';

export function recheckFormData(payload, files = []) {
  const form = new FormData();
  form.append('payload', JSON.stringify(payload));
  if (payload.capture_metadata) form.append('capture_metadata', payload.capture_metadata);
  files.forEach((file) => form.append('files', file));
  return form;
}

export async function sendCodeRecheck(violationId, payload, files) {
  const response = await apiFetch(`/violation/${violationId}/code-rechecks`, {
    method: 'POST', body: recheckFormData(payload, files),
  });
  if (!response.ok) {
    const error = new Error(await readResponseError(response, 'Unable to save this recheck.'));
    error.status = response.status;
    throw error;
  }
  return response.json();
}

export async function saveCodeRecheck({ violationId, payload, files, isOnline, queueAction }) {
  if (!payload.checks.length) throw Object.assign(new Error('Select an outcome for at least one code.'), { status: 422 });
  if (payload.checks.some((check) => check.outcome === 'complied') && !payload.photo_warning_acknowledged && !files.some((file) => file.type.startsWith('image/'))) {
    throw Object.assign(new Error('Add a compliance photo for the codes you marked complied.'), { status: 422 });
  }
  if (files.length && !payload.capture_metadata) {
    const metadata = new FormData();
    await appendGeoMetadata(metadata, { extraMetadata: { workflow: 'code-recheck', event_id: payload.event_id } });
    if (metadata.get('capture_metadata')) payload.capture_metadata = metadata.get('capture_metadata');
  }
  const queue = async () => {
    if (!queueAction) throw new Error('Offline saving is unavailable. Keep this form open and reconnect.');
    await queueAction({ type: 'code_recheck', clientId: payload.event_id,
      payload: { violationId, recheck: payload, files } });
    return { event_id: payload.event_id, sync_state: 'queued', drafts: [] };
  };
  if (!isOnline) return queue();
  try {
    return await sendCodeRecheck(violationId, payload, files);
  } catch (error) {
    // Preserve the visit ID when delivery is uncertain. Validation/conflicts stay
    // in the form for review rather than entering a retry loop.
    if (!error.status || [408, 425, 429].includes(error.status) || error.status >= 500) return queue();
    throw error;
  }
}
